"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationResourceFallback = exports.LocationRoomFallback = exports.LocationPlaceFallback = exports.LocationResourceImages = exports.LocationRoomImages = exports.LocationPlaceImages = void 0;
const location_1 = require("./location");
exports.LocationPlaceImages = {
    [location_1.LocationPlaceType.LOCATION]: '/assets/images/location.svg',
    [location_1.LocationPlaceType.OFFICE]: '/assets/images/office.svg',
    [location_1.LocationPlaceType.VID_CONFERENCE]: '',
    [location_1.LocationPlaceType.PHONE_INBOUND]: '',
    [location_1.LocationPlaceType.PHONE]: '',
    [location_1.LocationPlaceType.OUR_LOCATION]: '',
    [location_1.LocationPlaceType.IN_HOUSE]: '',
    [location_1.LocationPlaceType.IN_PERSON]: '',
    [location_1.LocationPlaceType.VIRTUAL_EVENT]: '',
    [location_1.LocationPlaceType.GOOGLE_LOCATION]: '',
};
exports.LocationRoomImages = {
    [location_1.LocationRoomType.RESOURCE]: '',
    [location_1.LocationRoomType.RECORD_TYPE]: '',
};
exports.LocationResourceImages = {
    [location_1.LocationResourceType.RESOURCE]: '',
};
exports.LocationPlaceFallback = '/assets/images/location.svg';
exports.LocationRoomFallback = '/assets/images/location.svg';
exports.LocationResourceFallback = '/assets/images/location.svg';
